<template>
  <li class="org-item" @click="$emit('select', item)">
    <img
      class="avatar"
      :src="item.small_pic_url"
      :onerror="defaultLogo"
      alt=""
    />
    <div class="info">
      <h4>{{ item.name }}</h4>
      <div class="detail">
        <ScoreModule :score="item.org_avg_score" :size="36"></ScoreModule>
        <span class="price">&yen;{{ item.min_price / 100 }}</span>
      </div>
    </div>
  </li>
</template>
<script>
import ScoreModule from "@/components/common/ScoreModule";

export default {
  components: {
    ScoreModule,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultLogo,
    };
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
@color-theme: #ff8008;
.org-item {
  color: #485464;
  display: flex;
  margin-top: 30/200rem;
  .avatar {
    width: 200/200rem;
    height: 164/200rem;
    margin-right: 30/200rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 16/200rem;
    border: 1/200rem solid rgba(238, 238, 238, 1);
    object-fit: contain;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    h4 {
      font-size: 32/200rem;
      .ellipsis-line(396/200rem, 2);
      font-weight: 400;
      line-height: 48/200rem;
    }
    .detail {
      display: flex;
      justify-content: space-between;
      .price {
        color: @color-theme;
        font-size: 32/200rem;
        font-weight: 600;
      }
    }
  }
}
</style>
